module.exports = "varying vec2 vUv;"